import { Box, ColorOptions, SpacerNew, TextInputNew, TextNew } from '@jfs/ui-new'
import { FC, useState } from 'react'
import { NativeSyntheticEvent, TextInputSelectionChangeEventData } from 'react-native'
import { TooltipView } from '../../../../../src/comps/TootTipView'
import { DropdownOptimised } from '../../../../comps/DropdownNew'
import { DropdownTypes } from '../../../../comps/DropdownNew/types'
import { passwordPlaceholder } from './helper'
import { styles } from './ReportingStyles'

export const insertDateFormatList = [
  { value: 'ddMMyyyy' },
  { value: 'yyyyMMdd' },
  { value: 'dd-MM-yyyy' },
  { value: 'yyyy-MM-dd' },
  { value: 'dd-MMM-yyyy' },
  { value: 'MMMM dd, yyyy' },
]

export const InfoDropdown: FC = ({
  setFieldValue,
  fieldName,
  data,
  title,
  placeHolder,
  onValueChange,
  ...props
}: any) => {
  let valueMapping = props.value
  if (fieldName === 'reportFormat' || fieldName === 'fileTransferMode') {
    switch (valueMapping) {
      case 'S':
        valueMapping = 'Standatd'
        break
      case 'C':
        valueMapping = 'Custom'
        break
      case 'C_RRL':
        valueMapping = 'Custom RRL'
        break
      case 'EMAIL_SFTP':
        valueMapping = 'Email and SFTP'
        break
    }
  }

  const [value, setValue] = useState(valueMapping)

  const syncFileModes = (val: any) => {
    if (fieldName === 'fileTransferMode' && props?.allValues) {
      if (val && value) {
        const values: any = JSON.parse(JSON.stringify(props.allValues))
        if (value === 'SFTP') {
          //console.log('value', values, values.sftpFileTransferConfig)
          let emailAndSftpFileTransferConfig = {
            ...values?.emailAndSftpFileTransferConfig,
          }
          if (values.sftpFileTransferConfig) {
            emailAndSftpFileTransferConfig = {
              ...emailAndSftpFileTransferConfig,
              ...values.sftpFileTransferConfig,
            }
          }
          // if (values.emailFileTransferConfig) {
          //   emailAndSftpFileTransferConfig = {
          //     ...emailAndSftpFileTransferConfig,
          //     ...values.emailFileTransferConfig,
          //   }
          // }
          setFieldValue('emailAndSftpFileTransferConfig', emailAndSftpFileTransferConfig)
        } else if (value === 'EMAIL') {
          let emailAndSftpFileTransferConfig = {
            ...values?.emailAndSftpFileTransferConfig,
          }
          if (values.emailFileTransferConfig) {
            emailAndSftpFileTransferConfig = {
              ...emailAndSftpFileTransferConfig,
              ...values.emailFileTransferConfig,
            }
          }
          setFieldValue('emailAndSftpFileTransferConfig', emailAndSftpFileTransferConfig)
        } else if (value === 'SFTP & EMAIL') {
          let allConfig = {}
          if (values.emailAndSftpFileTransferConfig) {
            allConfig = {
              ...values.emailAndSftpFileTransferConfig,
            }
          }
          setFieldValue('emailFileTransferConfig', allConfig)
          setFieldValue('sftpFileTransferConfig', allConfig)
        }
      }
    }
  }

  //const width = useWindowDimensions()
  return (
    <Box {...styles.mainView}>
      <Box {...styles.textAndIcon}>
        <Box {...styles.titleAligner}>
          <TextNew title={title} {...styles.titleText} />
        </Box>
        <Box>
          <TooltipView
            iconColor={'#202F4D8A' as ColorOptions}
            fontSize={12}
            value={props.tooltipInfo ?? ''}
            top={props.top ?? -20}
            iconSize={14}
          />
        </Box>
      </Box>
      <SpacerNew size={5} direction={'vertical'} />
      <Box {...styles.superContainer}>
        <DropdownOptimised
          placeHolder={placeHolder}
          data={data}
          value={value}
          onChange={(val: any) => {
            if (onValueChange) {
              syncFileModes(val)
              // console.log('value', value, val)
              // if (fieldName === 'reportFormat') {
              //   if (val === 'Custom RRL') {
              //     onValueChange(getReportExtensions(val))
              //     setFieldValue('reportExt', '')
              //   } else {
              //     onValueChange(getReportExtensions())
              //   }
              // }
            }
            if (setFieldValue && fieldName && val) {
              setFieldValue(fieldName, val)
              setValue(val)
            }
          }}
          // buttonWidth={width / 5}
          buttonWidth={'100%'}
          disabled={false}
          titleColor={value !== undefined ? 'BLACK_21' : 'LIGHT_GREY_INTRO'}
          borderColor={'#B9CBF0' as ColorOptions}
          testID={fieldName + 'test'}
          // dropdownWidth={width / 5}
          type={DropdownTypes.DEFAULT_WITH_IMAGE}
          containerStyle={{ minWidth: '100%', maxWidth: '100%' }}
        />
      </Box>
    </Box>
  )
}

export const FileModeTextInput: FC = ({
  onChangeText,
  title,
  placeHolder,
  editable,
  value,
  isOptional = false,
  insertDateTime = false,
  ...prop
}: any) => {
  const [error, setError] = useState('')
  const [startPosition, setStartPosition]: any = useState(0)

  const onDateChange = (selectedDateFormat: any) => {
    let valueString: any = value
    try {
      // if given format exist then replace the values insead of inserting new format
      const filtered = insertDateFormatList.find((item) => new RegExp(`${item.value}`, 'gi').test(valueString))
      if (filtered) {
        valueString = valueString?.replace(new RegExp(`<${filtered.value}>`, 'gi'), `<${selectedDateFormat}>`)
      } else {
        if (valueString) {
          valueString = `${valueString?.slice(0, startPosition)?.trim()} <${selectedDateFormat}> ${valueString
            ?.slice(startPosition)
            ?.trim()}`
        } else {
          valueString = `<${selectedDateFormat}>`
        }
      }
    } catch (e) {
      console.log('error while parsing insert date', e)
    }
    onChangeText(valueString)
  }

  const getPosition = (event: NativeSyntheticEvent<TextInputSelectionChangeEventData>) => {
    //console.log('event cursor', event, event?.nativeEvent?.selection?.start)
    setStartPosition(event?.nativeEvent?.selection?.start)
  }

  return (
    <Box {...styles.mainView} f={1}>
      <Box {...styles.textAndIcon}>
        <Box {...styles.titleAligner}>
          <TextNew title={`${title} ${isOptional ? '(Optional)' : ''}`} {...styles.titleText} />
        </Box>
        <Box>
          <TooltipView
            iconColor={'#202F4D8A' as ColorOptions}
            fontSize={12}
            value={prop.tooltipInfo ?? ''}
            top={prop.top ?? -10}
            iconSize={14}
          />
        </Box>
      </Box>
      <SpacerNew size={5} direction={'vertical'} />

      {/* <Box {...styles.superContainer}> */}
      <TextInputNew
        weight={'normal'}
        value={value}
        onChangeText={onChangeText}
        placeholder={placeHolder}
        type={'body12'}
        touched
        editable={editable}
        showBottomLine={false}
        textAlign={'left'}
        borderRadius={4}
        paddingHorizontal={8}
        focusBorderColor={'#B9CBF0' as ColorOptions}
        borderColor={'#B9CBF0' as ColorOptions}
        minHeight={35}
        error={error}
        rightComponent={insertDateTime ? <InsertDate onDateChange={onDateChange} /> : <></>}
        onSelectionChange={getPosition}
        onBlur={() => {
          if (!value && !isOptional) {
            setError('Required!')
          } else {
            setError('')
          }
        }}
        {...prop}
      />
      {/* </Box> */}
    </Box>
  )
}

const InsertDate = ({ onDateChange }) => {
  return (
    <Box>
      <DropdownOptimised
        placeHolder="Insert"
        data={insertDateFormatList}
        onChange={onDateChange}
        type={DropdownTypes.DEFAULT_WITH_BG}
        dropdownWidth={120}
        chevronColor={'BLUE' as ColorOptions}
        titleColor={'rgb(82, 139, 255)' as ColorOptions}
        dropDownContentFontSize={12}
        showBorder={false}
        borderColor={'TRANSPARENT'}
        containerStyle={{ backgroundColor: 'rgb(234, 241, 255)' as ColorOptions, borderRadius: 4 }}
        doropdownContainerTitle={''}
      />
    </Box>
  )
}

export const FileTranferTextInput: FC = ({ setFieldValue, fieldName, placeHolder, editable, title, ...prop }: any) => {
  const [value, setValue] = useState(prop.value)
  return (
    <Box {...styles.mainView} f={1}>
      <Box {...styles.textAndIcon} flexDirection="row">
        <Box {...styles.titleAligner} paddingHorizontal={8}>
          <TextNew title={title} {...styles.titleText} />
        </Box>
        <Box>
          <TooltipView
            iconColor={'#202F4D8A' as ColorOptions}
            fontSize={12}
            value={prop.tooltipInfo ?? ''}
            top={-35}
            iconSize={14}
          />
        </Box>
      </Box>
      <SpacerNew size={5} direction={'vertical'} />

      <TextInputNew
        weight={'normal'}
        value={value}
        onChangeText={(val: any) => {
          if (setFieldValue && fieldName && val) {
            setFieldValue(fieldName, val)
            setValue(val)
          }
        }}
        placeholder={placeHolder}
        type={'body12'}
        touched
        editable={editable}
        testID="refundInvoiceInput"
        showBottomLine={false}
        textAlign={'left'}
        borderRadius={4}
        padding={0}
        focusBorderColor={'#B9CBF0' as ColorOptions}
        borderColor={'#B9CBF0' as ColorOptions}
        minHeight={35}
        {...prop}
      />
    </Box>
  )
}

export const PassKeyTextInput: FC = ({ onChangeText, title, placeHolder, editable, value, sUpdate, ...prop }: any) => {
  const [error, setError] = useState('')
  return (
    <Box {...styles.mainView} f={1}>
      <Box {...styles.textAndIcon}>
        <Box {...styles.titleAligner}>
          <TextNew title={title} {...styles.titleText} />
        </Box>
        <Box>
          <TooltipView
            iconColor={'#202F4D8A' as ColorOptions}
            fontSize={12}
            value={prop.tooltipInfo ?? ''}
            top={prop.top ?? -10}
            iconSize={14}
          />
        </Box>
      </Box>
      <SpacerNew size={5} direction={'vertical'} />

      {/* <Box {...styles.superContainer}> */}
      <TextInputNew
        weight={'normal'}
        value={value}
        onChangeText={onChangeText}
        placeholder={placeHolder}
        type={'body12'}
        touched
        editable={editable}
        showBottomLine={false}
        textAlign={'left'}
        borderRadius={4}
        paddingHorizontal={8}
        focusBorderColor={'#B9CBF0' as ColorOptions}
        borderColor={'#B9CBF0' as ColorOptions}
        minHeight={35}
        error={error}
        onFocus={() => {
          //console.log('passwordPlaceholder', value, value === passwordPlaceholder)
          if (sUpdate && value === passwordPlaceholder) {
            onChangeText('')
          }
        }}
        onBlur={() => {
          //console.log('called', value)
          if (sUpdate && value === '') {
            onChangeText(passwordPlaceholder)
            //setError('Required!')
          } else {
            setError('')
          }
        }}
        {...prop}
      />
      {/* </Box> */}
    </Box>
  )
}
